import { useEffect, useRef, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import useTailwindTheme from 'hooks/useTailwindTheme';

export const STICKY_SHOP_NAVIGATION_STYLES = {
    sticky: 'sticky top-0 duration-200',
    notSticky: 'sticky duration-200',
    desktopSticky: 'sticky top-80 z-1000 py-10 mx-[-35px]! pr-[35px]',
    desktopStickyL2ScrollTop: 'sticky top-80 z-1000 pt-10 pb-0 mx-[-35px]! pr-[35px]',
    paddingTopNanobanner: 'pt-[140px] md:pt-[200px]',
    paddingTopNoNanobanner: 'pt-[160px]',
    paddingTopSignupNanobanner: 'pt-[160px]',
    paddingTopSignupNoNanobanner: 'pt-[100px]',
};

export default function useStickyShopNavigation() {
    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });
    const previousY = useRef(0);
    const blocking = useRef(false);

    const [sticky, setSticky] = useState(false);

    function updateStickyStatus() {
        const currentY = window.scrollY;

        const scrollDelta = previousY.current - currentY;
        const scrollDeltaThreshold = 10;
        const minScrollThreshold = 100;

        if (Math.abs(scrollDelta) > scrollDeltaThreshold) {
            if (currentY > minScrollThreshold) {
                setSticky(scrollDelta > 0);
            } else {
                setSticky(false);
            }
        }

        previousY.current = currentY;
        blocking.current = false;
    }

    function onScroll() {
        if (!blocking.current) {
            blocking.current = true;
            window.requestAnimationFrame(updateStickyStatus);
        }
    }

    useEffect(() => {
        if (mobile) {
            window.addEventListener('scroll', onScroll);
        }

        return () => {
            if (mobile) {
                window.removeEventListener('scroll', onScroll);
            }
        };
    }, [mobile]);

    return {
        sticky,
    };
}
